/**
 * Component: Swatch Listing
 * ------------------------------------------------------------------------------
 * An accessible function to trigger change variant img in PLP.
 *
 * @namespace SwatchListing
 */

import { throttle, on } from '~/helpers/utils';

/**
 * DOM selectors.
 */
const selectors = {
  product: '[js-product-swatches="product"]',
  productSwatch: '[js-product-swatches="option"]',
  productImage: '.product-card__thumbnail--variant',
  productImageLifestyle: '.product-card__thumbnail--lifestyle',
  productLink: '[js-product-link="variant"]',
};

/**
 * Create a new sticky filter object.
 */
export default () => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    product: document.querySelectorAll(selectors.product),
    productSwatch: document.querySelectorAll(selectors.productSwatch),
    productImage: document.querySelectorAll(selectors.productImage),
    productImageLifestyle: document.querySelector(selectors.productImageLifestyle),
    productLink: document.querySelector(selectors.productLink),
  };

  /**
   * Initialise component.
   */
  function init() {
    setInitialVariantImages();
    setEventListeners();
  }

  /**
   * Event listeners.
   */
  function setEventListeners() {
    nodeSelectors.product.forEach((product) => {

      const swatches = product.querySelectorAll(selectors.productSwatch);
      swatches.forEach((swatch) => {
        on('mouseenter', swatch, throttle(() => handleHover(product, swatch), 150));
      });
    });
  }

  function setInitialVariantImages() {
    nodeSelectors.product.forEach((product) => {
      const selectedSwatch = product.querySelector(`${selectors.productSwatch} a.selected`);
      
      if (selectedSwatch) {
        const variantId = selectedSwatch.parentNode.getAttribute('data-variant-id');
        changeImg(product, variantId);
      }
    });
  }
  
  

  function handleHover(product, swatch) {
    changeImg(product, swatch.getAttribute('data-variant-id'));
    selectedSwatch(product, swatch.getAttribute('data-variant-id'));
  }

  function selectedSwatch(product, variantId) {
    const swatches = product.querySelectorAll(selectors.productSwatch);
  
    swatches.forEach((swatch) => {
      const swatchVariantId = swatch.getAttribute('data-variant-id');
      const link = swatch.querySelector('a');
      const linkVariant = link.getAttribute('href')
  
      if (swatchVariantId === variantId) {
        link.classList.add('selected');
        product.querySelector(selectors.productLink).setAttribute('href', linkVariant)

      } else {
        link.classList.remove('selected');
      }
    });
  }
  

  function changeImg(product, variantId) {
    const images = product.querySelectorAll(selectors.productImage);
    images.forEach((img) => {
      const imgVariantId = img.getAttribute('data-variant-id');
      if (imgVariantId === variantId) {
        img.style.display = 'block';
        
      } else {
        img.style.display = 'none';
       
      }
    });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
